<template>
  <nav class="bg-transparent border-transparent curved-navbar">
    <div
      class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4"
    >
      <!-- Logo -->
      <a
        href="/"
        class="flex items-center space-x-3 rtl:space-x-reverse"
      >
        <img
          src="@/assets/logo.png"
          class="h-8"
          alt="Bang Pateng Logo"
        >
      </a>

      <!-- Mobile Menu Button -->
      <button
        type="button"
        class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-black rounded-lg md:hidden hover:bg-gray-800/50"
        @click="toggleMenu"
      >
        <span class="sr-only">Open main menu</span>
        <svg
          class="w-5 h-5"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 17 14"
        >
          <path
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M1 1h15M1 7h15M1 13h15"
          />
        </svg>
      </button>

      <!-- Navbar Items -->
      <div
        :class="menuOpen ? 'block' : 'hidden'"
        class="w-full md:block md:w-auto"
      >
        <ul
          class="flex flex-col font-medium p-4 md:p-0 mt-4 rounded-lg bg-white-900/80 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:bg-transparent"
        >
          <li>
            <a
              href="/"
              class="block py-2 px-3 text-black rounded md:bg-transparent md:p-0"
            >Home</a>
          </li>
          <li>
            <a
              href="/testnet"
              class="block py-2 px-3 text-black rounded md:bg-transparent md:p-0"
            >Testnet</a>
          </li>
          <li>
            <a
              href="/mainnet"
              class="block py-2 px-3 text-black rounded md:bg-transparent md:p-0"
            >Mainnet</a>
          </li>
          <li>
            <a
              href="https://explorer.winnode.xyz/"
              class="block py-2 px-3 text-black rounded md:bg-transparent md:p-0"
            >Explorer</a>
          </li>
          <li>
            <a
              href="/about"
              class="block py-2 px-3 text-black rounded md:bg-transparent md:p-0"
            >About</a>
          </li>
          <li>
            <a
              href="/contact"
              class="block py-2 px-3 text-black rounded md:bg-transparent md:p-0"
            >Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { ref } from "vue";

export default {
  setup() {
    const menuOpen = ref(false);

    const toggleMenu = () => {
      menuOpen.value = !menuOpen.value;
    };

    return { menuOpen, toggleMenu };
  },
};
</script>

<style scoped>
.curved-navbar {
  position: relative;
  background-color: rgba(255, 255, 255, 0.95); /* Warna biru gelap seperti Monad */
  border-radius: 5rem;
  margin: 1rem 25rem;
  padding: 0 1rem;
  box-shadow: 0 4px 20px rgba(255, 255, 255, 0.2);
}

@media (max-width: 768px) {
  .curved-navbar {
    border-radius: 1rem;
    margin: 0.5rem;
  }
}
</style>
